import type { CircleResult, SlopeSearchInput } from "../solver/slope-stability";

interface WorkerResponse { id: number; result?: CircleResult | null; error?: string }

let nextId = 1;
let worker: Worker | undefined;
const pending = new Map<number, { resolve: (value: CircleResult | null) => void; reject: (reason: Error) => void }>();

function getWorker(): Worker {
  if (worker) return worker;
  worker = new Worker(new URL("../worker/slope.worker.ts", import.meta.url), { type: "module" });
  worker.onmessage = (event: MessageEvent<WorkerResponse>) => {
    const request = pending.get(event.data.id);
    if (!request) return;
    pending.delete(event.data.id);
    if (event.data.error) request.reject(new Error(event.data.error));
    else request.resolve(event.data.result ?? null);
  };
  worker.onerror = (event) => {
    const error = new Error(event.message || "Slope worker failed");
    pending.forEach((request) => request.reject(error));
    pending.clear();
    worker?.terminate();
    worker = undefined;
  };
  return worker;
}

export function searchCriticalCircleAsync(input: SlopeSearchInput): Promise<CircleResult | null> {
  const id = nextId++;
  return new Promise((resolve, reject) => {
    pending.set(id, { resolve, reject });
    getWorker().postMessage({ id, input });
  });
}
